import React from 'react';
import _ from 'lodash';
import { TableContainer, Table, TableHead, TableRow, TableBody, TableCell, Paper } from '@mui/material';

export const SimpleView = props => {
  const { data } = props;

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell align="center">Nazwa</TableCell>
            <TableCell align="center">Szczegóły</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.camps.map(camp => (
            <TableRow
              key={camp}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >

              <TableCell align="center">
                {data.description}
              </TableCell>
              <TableCell align="center">
                {data.description ? data.description : ''}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
